import apiClient from "./axios"

export const getStatuses = async (params = {}) => {
  const { data } = await apiClient.get("/statuses", { params })
  return data
}

export const getStatus = async id => {
  const { data } = await apiClient.get(`/statuses/${id}`)
  return data
}

export const createStatus = async statusData => {
  const { data } = await apiClient.post("/statuses", statusData)
  return data
}

export const editStatus = async ({ id, ...statusData }) => {
  const { data } = await apiClient.patch(`/statuses/${id}`, statusData)
  return data
}

export const deleteStatus = async id => {
  const { data } = await apiClient.delete(`/statuses/${id}`)
  return data
}
